import { render, staticRenderFns } from "./CapitalShiftToHistory.vue?vue&type=template&id=22abffac&scoped=true&"
import script from "./CapitalShiftToHistory.vue?vue&type=script&lang=ts&"
export * from "./CapitalShiftToHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalShiftToHistory.vue?vue&type=style&index=0&id=22abffac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abffac",
  null
  
)

export default component.exports